/* Linfo Labs — comportamiento de la landing.
 * Replica la interaccion de la referencia (sliders, acordeones, marquee,
 * packs, carrito lateral, barra fija, fechas de entrega) con codigo propio.
 * Config en window.LL (layout/ll.liquid).
 */
(function () {
  'use strict';

  var LL = window.LL || {};
  var mqLarge = window.matchMedia('(width > 750px)');

  function money(cents) {
    var fmt = LL.moneyFormat || '${{amount}}';
    var v = (Number(cents) || 0) / 100;
    var s = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (/\.00$/.test(s)) s = s.slice(0, -3);
    return fmt.replace(/{{\s*\w+\s*}}/, s).replace(/\$\s+/, '$');
  }

  function debounce(fn, wait) {
    var t;
    function d() { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }
    d.cancel = function () { clearTimeout(t); };
    return d;
  }

  function define(name, cls) {
    if (!customElements.get(name)) customElements.define(name, cls);
  }

  function inViewport(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  /* ---------------------------------------------------------------- sliders */
  class SliderComponent extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      var start = function () {
        if (!window.Splide) { setTimeout(start, 50); return; }
        self.mount();
      };
      start();
    }
    mount() {
      var section = this.closest('.shopify-section');
      this.maxPageWidth = parseFloat(getComputedStyle(section).getPropertyValue('max-width'));
      this.slider = this.initMain();
      var thumbs = this.querySelector('[data-ref="thumbnail-slider"]');
      if (thumbs) {
        this.thumbnailSlider = new Splide(thumbs, {
          fixedWidth: 90, fixedHeight: 90, gap: 10, rewind: false, pagination: false, isNavigation: true,
          arrows: this.getAttribute('data-show-arrows-thumbnails') === 'true',
          breakpoints: { 750: { fixedWidth: 70, fixedHeight: 70 } }
        });
        this.slider.sync(this.thumbnailSlider);
      }
      var self = this;
      if (!this.thumbnailSlider) {
        this.slider.on('mounted', function () { self.updateSize(); });
        this.ro = new ResizeObserver(function () { self.updateSize(); });
        this.ro.observe(document.documentElement);
      }
      this.slider.mount();
      if (this.thumbnailSlider) this.thumbnailSlider.mount();
    }
    initMain() {
      var a = this.getAttribute.bind(this);
      var perMobile = a('data-per-page-mobile');
      if (perMobile === '1.8') perMobile = 1;
      return new Splide(this.querySelector('[data-ref="main-slider"]'), {
        perPage: perMobile, perMove: 1, rewind: a('data-rewind') === 'true', gap: a('data-gap') + 'px',
        drag: true, noDrag: '.before-after-block__slider, .before-after-block__slider *', snap: true,
        arrows: a('data-show-arrows-mobile') === 'true', pagination: a('data-show-pagination-mobile') === 'true',
        autoplay: a('data-autoplay') === 'true', interval: Number(a('data-autoplay-speed') + '000'),
        autoHeight: true, lazyLoad: false, flickMaxPages: 1, flickPower: 400, mediaQuery: 'min',
        breakpoints: { 750: { perPage: a('data-per-page-desktop'), pagination: a('data-show-pagination') === 'true', arrows: a('data-show-arrows') === 'true' } }
      });
    }
    updateSize() {
      var section = this.closest('.shopify-section');
      var pageWidth = document.documentElement.clientWidth;
      var pad = parseFloat(getComputedStyle(section).getPropertyValue('padding-right')) || 0;
      if (pageWidth > this.maxPageWidth) pad = (pageWidth - this.maxPageWidth) / 2 + pad;
      this.style.width = 'calc(100% + ' + 2 * pad + 'px)';
      this.style.marginLeft = '-' + pad + 'px';
      this.style.marginRight = '-' + pad + 'px';
      var track = this.querySelector('.splide__track');
      if (track) { track.style.paddingRight = pad + 'px'; track.style.paddingLeft = pad + 'px'; }
      var prev = this.querySelector('.splide__arrow--prev'), next = this.querySelector('.splide__arrow--next');
      if (prev && next) { prev.style.left = pad + 10 + 'px'; next.style.right = pad + 10 + 'px'; }
    }
  }
  define('slider-component', SliderComponent);

  /* ------------------------------------------------------------- acordeones */
  class AccordionRow extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.set = function () {
        var d = self.querySelector('[data-ref="accordion-details"]');
        if (!d) return;
        var mobile = !mqLarge.matches;
        d.open = (mobile && self.hasAttribute('open-by-default-on-mobile')) || (!mobile && self.hasAttribute('open-by-default-on-desktop'));
      };
      this.set();
      mqLarge.addEventListener('change', this.set);
    }
    disconnectedCallback() { mqLarge.removeEventListener('change', this.set); }
  }
  define('accordion-row', AccordionRow);

  /* ---------------------------------------------------------------- marquee */
  class MarqueeComponent extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.querySelector('[data-ref="wrapper"]');
      this.content = this.querySelector('[data-ref="content"]');
      if (!this.wrapper || !this.content || !this.content.firstElementChild || this.content.firstElementChild.children.length === 0) return;
      this.addCopies();
      this.duplicate();
      this.setSpeed();
      var self = this;
      window.addEventListener('resize', debounce(function () {
        var want = self.copies(), have = self.content.children.length;
        if (want > have) self.addCopies(want - have + 1);
        else for (var i = 0; i < have - want; i++) self.content.lastElementChild && self.content.lastElementChild.remove();
        self.duplicate(); self.setSpeed();
      }, 250));
    }
    copies() {
      var w = this.offsetWidth, iw = this.content.firstElementChild.offsetWidth || 1;
      return Math.ceil(w / iw);
    }
    addCopies(n) {
      n = n || this.copies();
      var first = this.content.firstElementChild;
      for (var i = 0; i < n - 1; i++) this.content.appendChild(first.cloneNode(true));
    }
    duplicate() {
      var last = this.wrapper.lastElementChild;
      if (last && last !== this.content) last.remove();
      var c = this.content.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-ref');
      this.wrapper.appendChild(c);
    }
    setSpeed() {
      var f = Number(this.getAttribute('data-speed-factor')) || 20;
      var s = Math.ceil(this.offsetWidth / f / 2) * (window.matchMedia('(max-width: 749px)').matches ? 1.25 : 1);
      this.style.setProperty('--marquee-speed', s + 's');
    }
  }
  define('marquee-component', MarqueeComponent);

  /* ------------------------------------------------------------------ header */
  class HeaderComponent extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.toggle = this.querySelector('[data-ref="menu-toggle"]');
      this.closeBtn = this.querySelector('[data-ref="menu-close"]');
      this.overlay = this.querySelector('[data-ref="mobile-menu-overlay"]');
      if (this.toggle) this.toggle.addEventListener('click', function () { self.open(); });
      if (this.closeBtn) this.closeBtn.addEventListener('click', function () { self.close(); });
      if (this.overlay) this.overlay.addEventListener('click', function (e) { if (e.target === self.overlay) self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.overlay && self.overlay.classList.contains('is-open')) self.close(); });
      var upd = function () { self.style.setProperty('--header-offset-height', self.offsetHeight + 'px'); };
      upd();
      new ResizeObserver(upd).observe(this);
      var group = this.closest('.shopify-section-group-header-group');
      if (group && getComputedStyle(group).position === 'sticky') {
        var top = 0;
        document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) { if (s !== group) top += s.offsetHeight; });
        var check = function () { self.dataset.stickyState = window.scrollY >= (top || 20) ? 'active' : 'inactive'; };
        window.addEventListener('scroll', check, { passive: true });
        check();
      }
    }
    open() {
      this.overlay.classList.remove('is-closing');
      this.overlay.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    }
    close() {
      var o = this.overlay;
      o.classList.add('is-closing');
      setTimeout(function () { o.classList.remove('is-open', 'is-closing'); document.body.classList.remove('overflow-hidden'); }, 125);
    }
  }
  define('header-component', HeaderComponent);
  define('dropdown-group-component', class extends HTMLElement {});

  /* ------------------------------------------------------- fecha de entrega */
  class DeliveryEstimation extends HTMLElement {
    connectedCallback() {
      var min = parseInt(this.dataset.minDays, 10) || 4, max = parseInt(this.dataset.maxDays, 10) || 10;
      var business = this.dataset.businessDays === 'true';
      var cutoff = this.dataset.cutoffHour ? parseInt(this.dataset.cutoffHour, 10) : null;
      var locale = this.dataset.locale || 'es-MX';
      function add(n) {
        var d = new Date();
        if (cutoff !== null && d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
        var added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          var wd = d.getDay();
          if (!business || (wd !== 0 && wd !== 6)) added++;
        }
        return d;
      }
      var f = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long' });
      var a = this.querySelector('[data-ref="min-date"]'), b = this.querySelector('[data-ref="max-date"]');
      if (a) a.textContent = f.format(add(min)).replace(',', '');
      if (b) b.textContent = f.format(add(max)).replace(',', '');
    }
  }
  define('delivery-estimation', DeliveryEstimation);

  /* ---------------------------------------------------------- video diferido */
  class DeferredMedia extends HTMLElement {
    connectedCallback() {
      var self = this;
      var poster = this.querySelector('[data-ref="deferred-media-poster"]');
      if (poster) poster.addEventListener('click', function () { self.load(); });
    }
    load() {
      if (this.getAttribute('data-media-loaded')) return;
      var tpl = this.querySelector('template');
      var node = tpl && tpl.content.firstElementChild && tpl.content.firstElementChild.cloneNode(true);
      if (!node) return;
      var src = node.querySelector && node.querySelector('source[src]');
      if (node.tagName === 'VIDEO' && !(src && src.getAttribute('src'))) return; /* video pendiente */
      // La carga nace de un click: reproducir la reseña con sonido.
      if (node.tagName === 'VIDEO') { node.muted = false; node.defaultMuted = false; node.removeAttribute('muted'); }
      this.setAttribute('data-media-loaded', 'true');
      var holder = this.querySelector('[data-ref="deferred-media-video"]');
      if (holder) holder.appendChild(node);
      if (node.tagName === 'VIDEO' && node.hasAttribute('autoplay')) node.play().catch(function () { node.controls = true; });
    }
  }
  define('deferred-media', DeferredMedia);

  /* ------------------------------------------------------------------- carrito */
  var Cart = {
    section: 'll-cart-drawer',
    drawer: function () { return document.querySelector('cart-drawer'); },
    render: function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('cart-drawer');
      var cur = this.drawer();
      if (!fresh || !cur) return;
      cur.querySelector('.cart-drawer__inner').innerHTML = fresh.querySelector('.cart-drawer__inner').innerHTML;
      cur.classList.toggle('cart-drawer--empty', fresh.classList.contains('cart-drawer--empty'));
      cur.dataset.count = fresh.dataset.count;
      document.querySelectorAll('[data-ref="cart-count"]').forEach(function (b) { b.textContent = fresh.dataset.count || '0'; });
    },
    req: function (url, body) {
      body = body || {};
      body.sections = this.section;
      body.sections_url = window.location.pathname;
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    refresh: function () {
      var self = this;
      return fetch(window.location.pathname + '?sections=' + this.section).then(function (r) { return r.json(); }).then(function (j) { self.render(j[self.section]); });
    },
    add: function (items) {
      var self = this;
      return this.req('/cart/add.js', { items: items }).then(function (j) { self.render(j.sections && j.sections[self.section]); return self.syncGifts(); });
    },
    change: function (key, qty) {
      var self = this;
      return this.req('/cart/change.js', { id: key, quantity: qty }).then(function (j) { self.render(j.sections && j.sections[self.section]); return self.syncGifts(); });
    },
    /* Regalos (ebook + garantía desde 3 frascos en México y 5 en el resto; pastillero y giftcard $350 desde 5, solo México):
       NO se agregan como productos (cada producto agregado manda un AddToCart a Meta e infla los agregados al carrito).
       El carrito los muestra solo como aviso; el pedido los lleva en la nota "Regalos" (atributo del carrito) y el renglón del colágeno
       en la propiedad "Incluye", que se ve en el checkout. Ninguna de las dos dispara eventos.
       Si quedó algún regalo como producto (carritos viejos), se quita. */
    syncGifts: function () {
      // Regalos como renglones a $0 (se ven en el checkout: GRATIS x4 y al final el frasco). Se agregan por la Storefront API
      // (cartLinesAdd): el píxel de Meta solo escucha /cart/add|update, así sale 1 solo AddToCart por compra.
      var self = this;
      var keys = Object.keys(LL.gifts || {}).filter(function (k) { return LL.gifts[k]; });
      var giftIds = keys.map(function (k) { return LL.gifts[k]; });
      var sizes = LL.packSize || {};
      var isGift = function (i) { return giftIds.indexOf(i.variant_id) > -1 || !!(i.properties && i.properties._ll_gift); };
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var units = cart.items.reduce(function (s, i) { return s + (isGift(i) ? 0 : i.quantity * (sizes[i.variant_id] || 0)); }, 0);
        var minOf = function (k) { return (LL.giftMin && LL.giftMin[k]) || LL.giftMinUnits || 5; };
        var names = { ebook: 'Ebook Protocolo Libertad', garantia: 'Garantía Libertad 60 días', pastillero: 'Pastillero semanal', giftcard: 'Giftcard $350 (por email)' };
        var want = keys.filter(function (k) { return units >= minOf(k); });
        var wantIds = want.map(function (k) { return LL.gifts[k]; });
        var nota = want.map(function (k) { return names[k] || k; }).join(' + ');
        var gifts = cart.items.filter(isGift);
        // bien = los regalos pedidos, 1 de cada uno, arriba de todo y en orden
        var bien = gifts.length === wantIds.length && cart.items.slice(0, wantIds.length).every(function (i, n) { return i.variant_id === wantIds[n] && i.quantity === 1 && !(i.properties && i.properties._ll_gift); });
        var updates = {};
        if (!bien) gifts.forEach(function (i) { updates[i.key] = 0; });
        var body = {};
        if (Object.keys(updates).length) body.updates = updates;
        if ((cart.attributes || {}).Regalos !== nota) body.attributes = { Regalos: nota };
        var main = cart.items.filter(function (i) { return sizes[i.variant_id] && i.properties && i.properties.Incluye; })[0];
        var p = Promise.resolve();
        if (body.updates || body.attributes) p = p.then(function () { return self.req('/cart/update.js', body); }).then(function (j) { self.render(j.sections && j.sections[self.section]); });
        if (main) p = p.then(function () { var props = Object.assign({}, main.properties); delete props.Incluye; return self.req('/cart/change.js', { id: main.key, quantity: main.quantity, properties: props }); }).then(function (j) { self.render(j.sections && j.sections[self.section]); });
        if (!bien && wantIds.length) p = p.then(function () {
          var q = 'mutation($id: ID!, $l: [CartLineInput!]!) { cartLinesAdd(cartId: $id, lines: $l) { userErrors { message } } }';
          var lines = wantIds.slice().reverse().map(function (id) { return { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }; });
          return fetch('/api/2025-07/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query: q, variables: { id: 'gid://shopify/Cart/' + cart.token, l: lines } }) });
        }).then(function () { return self.req('/cart/update.js', { attributes: { Regalos: nota } }); }).then(function (j) { self.render(j.sections && j.sections[self.section]); });
        return p;
      });
    }
  };
  window.LLCart = Cart;

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('.cart-drawer__close') || t.closest('[data-ref="continue-shopping"]')) { e.preventDefault(); self.close(); return; }
        var inner = self.querySelector('.cart-drawer__inner');
        if (inner && !inner.contains(t)) { self.close(); return; }
        var rm = t.closest('[data-ref="remove-item"]');
        if (rm) { e.preventDefault(); self.busy(Cart.change(rm.dataset.key, 0)); return; }
        var qb = t.closest('[data-ref="quantity-selector-button"]');
        if (qb) {
          e.preventDefault();
          var input = qb.parentElement.querySelector('input');
          var q = parseInt(input.value, 10) || 0;
          q = qb.name === 'plus' ? q + 1 : Math.max(0, q - 1);
          input.value = q;
          self.busy(Cart.change(qb.dataset.key, q));
          return;
        }
        var co = t.closest('[data-ref="checkout-button"]');
        if (co) co.classList.add('is-loading');
      });
      this.addEventListener('change', function (e) {
        var input = e.target.closest('[data-ref="quantity-selector-input"]');
        if (input) self.busy(Cart.change(input.dataset.key, Math.max(0, parseInt(input.value, 10) || 0)));
      });
    }
    busy(p) {
      var self = this;
      this.classList.add('is-updating');
      p.catch(function () {}).then(function () { self.classList.remove('is-updating'); });
    }
    open() {
      this.classList.remove('is-closing');
      this.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      startReservation();
    }
    close() {
      var self = this;
      this.classList.add('is-closing');
      setTimeout(function () { self.classList.remove('is-open', 'is-closing'); document.body.classList.remove('overflow-hidden'); }, 125);
    }
  }
  define('cart-drawer', CartDrawer);
  define('cart-drawer-item', class extends HTMLElement {});
  define('quantity-selector', class extends HTMLElement {});

  class CartIcon extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', function () {
        var d = Cart.drawer();
        if (d) d.open(); else window.location.href = '/cart';
      });
    }
  }
  define('cart-icon', CartIcon);

  /* En /cart el carrito es el mismo cajon lateral: se abre solo. */
  if (/^\/cart\/?$/.test(location.pathname)) {
    window.addEventListener('load', function () { var d = Cart.drawer(); if (d) d.open(); });
  }

  /* Temporizador "Tus productos estan reservados por 07:00" (7 min por carrito). */
  var resTimer = null;
  function startReservation() {
    var el = document.querySelector('cart-reservation');
    if (!el) return;
    var key = 'll-cart-reservation';
    var mins = parseInt(el.dataset.durationMinutes, 10) || 7;
    var exp = parseInt(localStorage.getItem(key) || '0', 10);
    if (!exp || exp < Date.now() - 3600e3) { exp = Date.now() + mins * 60e3; try { localStorage.setItem(key, String(exp)); } catch (e) {} }
    clearInterval(resTimer);
    var tick = function () {
      var el2 = document.querySelector('cart-reservation');
      if (!el2) return;
      var timer = el2.querySelector('[data-ref="timer"]'), run = el2.querySelector('[data-ref="running"]'), end = el2.querySelector('[data-ref="ended"]');
      var left = exp - Date.now();
      if (left <= 0) { run && run.classList.add('hidden'); end && end.classList.remove('hidden'); clearInterval(resTimer); return; }
      var s = Math.ceil(left / 1000);
      if (timer) timer.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    };
    tick();
    resTimer = setInterval(tick, 1000);
  }

  /* -------------------------------------------------------------------- packs */
  function packsRoot() { return document.querySelector('ll-packs'); }
  function selectedBar() {
    var root = packsRoot();
    return root && (root.querySelector('.kaching-bundles__bar--selected') || root.querySelector('.kaching-bundles__bar'));
  }
  function selectPack(bar) {
    var root = packsRoot();
    if (!root || !bar) return;
    root.querySelectorAll('.kaching-bundles__bar').forEach(function (b) {
      var on = b === bar;
      b.classList.toggle('kaching-bundles__bar--selected', on);
      var r = b.querySelector('input[type="radio"]');
      if (r) r.checked = on;
    });
    var form = document.getElementById('ll-product-form');
    if (form) {
      form.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = bar.dataset.variantId; });
      form.querySelectorAll('input[name="quantity"]').forEach(function (i) { i.value = bar.dataset.quantity || 1; });
    }
  }
  document.addEventListener('click', function (e) {
    var bar = e.target.closest && e.target.closest('ll-packs .kaching-bundles__bar');
    if (!bar) return;
    if (e.target.closest('a')) e.preventDefault();
    selectPack(bar);
  });

  function addSelected(btn) {
    var bar = selectedBar();
    if (!bar) return Promise.resolve();
    var id = Number(bar.dataset.variantId);
    if (btn) btn.classList.add('is-loading');
    return Cart.add([{ id: id, quantity: Number(bar.dataset.quantity) || 1 }])
      .then(function () { var d = Cart.drawer(); if (d) d.open(); })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'No se pudo agregar al carrito.'); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  /* En captura (window) para ganarle a scripts de apps: el envío nativo del form
     no sincroniza los regalos del pack. */
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#ll-product-form [data-ref="add-to-cart-button"]');
    if (!btn) return;
    e.preventDefault();
    if (!btn.classList.contains('is-loading')) addSelected(btn);
  }, true);
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id !== 'll-product-form') return;
    e.preventDefault();
    var btn = form.querySelector('[data-ref="add-to-cart-button"]');
    if (!btn || !btn.classList.contains('is-loading')) addSelected(btn);
  }, true);

  /* Barra fija de Kaching: visible cuando el selector de packs sale de pantalla. */
  function initSticky() {
    var sticky = document.querySelector('.kaching-bundles-sticky-atc-wrapper kaching-bundles-sticky-atc');
    if (!sticky) return;
    var btn = sticky.querySelector('.kaching-bundles-sticky-atc__button');
    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); addSelected(btn); });
    var target = document.getElementById('ll-product-form') || packsRoot();
    var footer = document.querySelector('.footer-section, footer');
    var upd = function () {
      var show = target && !inViewport(target) && !inViewport(packsRoot()) && target.getBoundingClientRect().bottom < 0 && !inViewport(footer);
      sticky.classList.toggle('kaching-bundles-sticky-atc--visible', !!show);
    };
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* Boton del formulario: queda siempre en su lugar, nunca fijo arriba del formulario.
     La unica barra fija es la de Kaching, que aparece recien despues de pasar el boton de compra. */
  class StickyAddToCart extends HTMLElement {
    connectedCallback() { this.dataset.active = 'false'; }
  }
  define('sticky-add-to-cart', StickyAddToCart);
  define('product-form', class extends HTMLElement {});
  define('ll-packs', class extends HTMLElement {});

  /* ------------------------------------------------------------------- popup */
  function initPopup() {
    if (!LL.popup) return;
    var pop = document.querySelector('[data-ll-popup]');
    if (!pop) return;
    var key = 'll-popup-closed';
    try { if (localStorage.getItem(key)) return; } catch (e) {}
    var close = function () { pop.style.display = 'none'; try { localStorage.setItem(key, '1'); } catch (e) {} };
    setTimeout(function () { pop.style.display = ''; }, 6000);
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-ll-popup-close]')) { e.preventDefault(); close(); }
      if (e.target.closest('[data-ll-popup-claim]')) {
        e.preventDefault();
        fetch('/discount/' + encodeURIComponent(LL.popupCode || 'HOLA5')).then(close, close);
      }
    });
  }

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    initSticky();
    initPopup();
    var cnt = Cart.drawer() && Cart.drawer().dataset.count;
    if (cnt) document.querySelectorAll('[data-ref="cart-count"]').forEach(function (b) { b.textContent = cnt; });
    window.LLmoney = money;
  });
})();
